import { useState } from "react";
import { naturezaJuridicaSelect, porteSelect, capitalSocialSelect, numeroEstabelecimentosSelect, quantidadeSociosSelect } from "../../../../config/data";
import SelectBasic from "../../../form/SelectBasic";
import { Col, Row } from "antd";
import { usePostHog } from "posthog-js/react";

export default function LegalFinancesFilter({ onChange, aiGeneration = false }: any) {
  const [naturezaJuridica, setNaturezaJuridica] = useState<string | string[]>([]);
  const [porte, setPorte] = useState<string | string[]>([]);
  const [capitalSocial, setCapitalSocial] = useState<string[]>([]);
  const [numeroEstabelecimentos, setNumeroEstabelecimentos] = useState<string | string[]>([])
  const [quantidadeSocios, setQuantidadeSocios] = useState<string | string[]>([])

  const posthog = usePostHog();

  const handleChange = (field: string, value: string[] | string) => {
    onChange(field, value); 
  };

  return (
    <div className={aiGeneration ? "aiGenerationLegalFilter" : "lead-genenation-filter-wrapper"}>
      <Row gutter={[16,16]} style={{display:'flex', justifyContent: 'space-between'}}>
        <Col span={7}  style={{display: aiGeneration ? 'none': 'inherit'}}>
          <SelectBasic
            expandDropdown
            mode="multiple"
            name="natjur"
            label="Natureza Jurídica"
            options={naturezaJuridicaSelect}
            value={naturezaJuridica}
            onChange={(value) => {
              posthog.capture('selecionar_natureza_juridica_select');
              setNaturezaJuridica(value);
              handleChange("naturezaJuridica", value);
            }}
          />
        </Col>
        <Col  span={aiGeneration ? 24 : 7}>
          <SelectBasic
            mode="multiple"
            name="porte"
            label="Porte"
            options={porteSelect}
            value={porte}
            onChange={(value) => {
              posthog.capture('selecionar_porte_select');
              setPorte(value);
              handleChange("porte", value);
            }}
          />
        </Col>
        <Col span={7}  style={{display: aiGeneration ? 'none': 'inherit'}}>
          <SelectBasic
            mode="multiple"
            name="capital_social"
            label="Capital Social"
            options={capitalSocialSelect}
            value={capitalSocial}
            onChange={(value) => {
              posthog.capture('selecionar_capital_social_select');
              setCapitalSocial([...value]);
              handleChange("capitalSocial", value);
            }}
          />
        </Col>
      </Row>
      <Row gutter={[16,16]} style={{display:'flex', justifyContent: 'space-between'}}>
        <Col span={7}  style={{display: aiGeneration ? 'none': 'inherit'}}>
          <SelectBasic
            mode="multiple"
            name="numeroEstabelecimentos"
            label="Número de estabelecimentos"
            options={numeroEstabelecimentosSelect}
            value={numeroEstabelecimentos}
            onChange={(value) => {
              posthog.capture('selecionar_natureza_juridica_select');
              setNumeroEstabelecimentos(value);
              handleChange("numeroEstabelecimentos", value);
            }}
          />
        </Col>
        <Col span={7}  style={{display: aiGeneration ? 'none': 'inherit'}}>
          <SelectBasic
            mode="multiple"
            name="quantidadeSocios"
            label="Quantidade de sócios"
            options={quantidadeSociosSelect}
            value={quantidadeSocios}
            onChange={(value) => {
              posthog.capture('selecionar_porte_select');
              setQuantidadeSocios(value);
              handleChange("quantidadeSocios", value);
            }}
          />
        </Col>
        <Col span={7}/>
      </Row>
      <span  style={{display: aiGeneration ? 'none': 'inherit'}} className="lead-genenation-filter-wrapper-footer">Não é necessário preencher todos os campos ou filtros</span>
    </div>
  );
}